import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IRootState } from '../app.config';
import { Store } from '@ngrx/store';
import { selectIsLoading } from '../../shared/app-configuration/app-configuration.reducer';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit {

  @Input()
  isLoading: boolean | null = false;

  loadingOverride: boolean = false;

  constructor(private cd: ChangeDetectorRef, private store$: Store<IRootState>) { }

  ngOnInit(): void {
    this.store$.select(selectIsLoading).subscribe(isLoading => {
      this.isLoading = isLoading;
      this.cd.detectChanges();
    });
  }
}
